export default "__VITE_ASSET__Carq9wHr__"